var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCreateTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42486",
    "data-name": "Group 42486",
    transform: "translate(15823 16169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15517",
    "data-name": "Rectangle 15517",
    width: 16,
    height: 16,
    transform: "translate(-15823 -16169)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-15822.62 -16168.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36981",
    "data-name": "Path 36981",
    d: "M15.423,22.081H7.666a.416.416,0,1,1,0-.831h7.758a.416.416,0,1,1,0,.831Z",
    transform: "translate(-2.42 -8.987)",
    fill: "#1564e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36982",
    "data-name": "Path 36982",
    d: "M18.1,2.7l-1.391-1.4a.892.892,0,0,0-1.263.105L14.18,2.7l2.549,2.549L17.992,3.99a1.053,1.053,0,0,0,.321-.731A.743.743,0,0,0,18.1,2.7Z",
    transform: "translate(-5.51 0)",
    fill: "#1564e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36983",
    "data-name": "Path 36983",
    d: "M8.082,5,2.624,10.469a1.075,1.075,0,0,0-.3.554l-.488,2.089a.61.61,0,0,0,.15.554.6.6,0,0,0,.416.166.687.687,0,0,0,.15,0l2.089-.521a1.108,1.108,0,0,0,.554-.3l5.464-5.458Z",
    transform: "translate(0 -1.742)",
    fill: "#1564e8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCreateTicket);
export default __webpack_public_path__ + "static/media/event-create-ticket.f2eb09d356927d457d00c7ed771c9d8d.svg";
export { ForwardRef as ReactComponent };